import { render, staticRenderFns } from "./Tester.vue?vue&type=template&id=4750034d&lang=pug&"
import script from "./Tester.vue?vue&type=script&lang=ts&"
export * from "./Tester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports